import { useContext, createContext } from 'react';

export const HistoryGoPartsContext = createContext((partsName?: string | null) => partsName === '');

export const useHistoryGoParts = (): void => useContext(HistoryGoPartsContext);
